<template>
  <cube-page :title="title">
    <div slot="content" v-loading="loading">
      <div id="deptAreaDistribution"></div>
    </div>
  </cube-page>
</template>
<script>
import { S2Event, PivotSheet } from '@antv/s2'
import { biData } from '@/api/cube'
import { ValueFormateHandler } from 'wmq-component'

import CubePage from '../../components/cube-page'

export default {
  name: 'DeptAreaDistribution',
  components: {
    CubePage
  },
  data () {
    return {
      loading: true,
      table: undefined,
      tableOptions: {
        width: 345,
        height: 600,
        interaction: {
          linkFields: ['province']
        },
        'totals': {
          'row': {
            'showGrandTotals': true
          }
        }
      }
    }
  },
  computed: {
    title () {
      return this.$route.query.dept + this.$route.query.type
    }
  },
  beforeMount () {
    window.addEventListener('resize', this.resizeHandler)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.resizeHandler)
    this.table.destroy()
  },
  created () {
    const yearDate = this.$route.query.year
    const trackId = 'deptAreaDistribution' + this.$route.query.type
    const reqObj = {
      channelType: this.$route.query.channelType,
      productBrand: this.$route.query.productBrand,
      year: yearDate,
      dept: this.$route.query.dept
    }
    biData(trackId, reqObj)
      .then((res) => {
        if (res.code === 1) {
          return res.data
        }
      })
      .then((res) => {
        const container = document.getElementById('deptAreaDistribution')

        res.meta.forEach(item => {
          if (item.format) {
            item.formatter = (value) => {
              return ValueFormateHandler.format(value, item.format)
            }
          }
        })
        const s2Theme = {
          rowCell: {
            text: {
              linkTextFill: '#33a3dc'
            }
          }
        }

        const options = JSON.parse(JSON.stringify(this.tableOptions))
        const screenWidth = document.documentElement.clientWidth
        const screenHeight = document.documentElement.clientHeight
        options.height = options.height / 667 * screenHeight
        options.width = options.width / 375 * screenWidth
        this.table = new PivotSheet(container, res, options)

        this.table.on(S2Event.GLOBAL_SELECTED, (data) => {
          if (data[0].meta.key === 'province' && data[0].meta.label !== '总计') {
            const province = data[0].meta.label
            this.$router.push({
              name: 'regionalDistribution',
              query: { province, year: this.$route.query.year, channelType: this.$route.query.channelType, productBrand: this.$route.query.productBrand, type: this.$route.query.type }
            })
          }
        })
        this.table.setThemeCfg({ theme: s2Theme })
        this.table.render()
      })
      .finally(() => {
        this.loading = false
      })
  },
  methods: {
    resizeHandler () {
      const screenWidth = document.documentElement.clientWidth
      const screenHeight = document.documentElement.clientHeight
      self.$nextTick(() => {
        self.table.changeSize(self.tableOptions.width / 375 * screenWidth, self.tableOptions.height / 667 * screenHeight)
        self.table.render(false)
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
#deptAreaDistribution{
   margin: 30px
    touch-action: none;
  }
</style>
